import { PhotoIcon, TypographyIcon, VideoIcon } from '@fourthwall/icons'

import type { TypeButton } from '../../../../../Post/components/PostTypeButtons/types'

export const TYPE_BUTTONS: TypeButton[] = [
  {
    type: 'Text',
    label: 'Text',
    icon: TypographyIcon,
  },
  {
    type: 'Image',
    label: 'Image',
    icon: PhotoIcon,
  },
  {
    type: 'Video',
    label: 'Video',
    icon: VideoIcon,
  },
]
